/* eslint-disable */
import Resource from "@/api/resource";
const optionResource = new Resource("theoptions");

export function findoptions(options, parent, brut = false) {

    //console.log("utilsfindoption" + slug);
    for(var slug in options ){
        optionResource
            .list({slug: slug})
            .then(response => {
                // console.log("utilsfound " + response.data)
                if (response.data) {
                    //options[slug]=response.data;
                    var d = brut
                        ? response.data
                        : response.data.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    parent.callbackoptions(response.slug, d);
                    // parent.callbackoptions(response.slug, response.data);
                }

            })
            .catch(error => {
                // console.log("utilsfounderrror " + error)
                //this.options[slug]='_';
            });

    }

}
